import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AuthShowcase from '../components/AuthShowcase';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    const formData = new FormData(event.currentTarget);
    const submittedName = String(formData.get('name') || name).trim();
    const submittedEmail = String(formData.get('email') || email).trim();
    const submittedPassword = String(formData.get('password') || password);
    try {
      await register(submittedName, submittedEmail, submittedPassword);
      navigate('/');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="auth-page">
      <AuthShowcase />
      <div className="auth-card">
        <div className="auth-card-top">
          <span className="auth-kicker">Kayit</span>
          <h2>TahminArena topluluguna katilin</h2>
          <p>Bir hesap olusturun, premium veri duvarina ve dikkat ceken arayuze giris yapin.</p>
        </div>

        {error && <div className="error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Ad Soyad</label>
            <input
              type="text"
              name="name"
              value={name}
              onChange={(event) => setName(event.target.value)}
              onInput={(event) => setName(event.currentTarget.value)}
              placeholder="Adiniz ve soyadiniz"
              autoComplete="name"
              required
            />
          </div>

          <div className="form-group">
            <label>E-posta</label>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              onInput={(event) => setEmail(event.currentTarget.value)}
              placeholder="ornek@tahminarena.com"
              autoComplete="email"
              autoCapitalize="off"
              autoCorrect="off"
              spellCheck="false"
              required
            />
          </div>

          <div className="form-group">
            <label>Sifre</label>
            <input
              type="password"
              name="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              onInput={(event) => setPassword(event.currentTarget.value)}
              placeholder="En az 6 karakter"
              autoComplete="new-password"
              required
            />
          </div>

          <button type="submit" className="btn-primary">Kayit Ol</button>
        </form>

        <p>Zaten hesabiniz var mi? <Link to="/login">Giris Yap</Link></p>
      </div>
    </div>
  );
};

export default Register;
